"use strict";

require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = RenderRow;
require("core-js/modules/es.function.name.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _fieldOld = _interopRequireDefault(require("../fieldOld"));
var _interfaceTransformer = _interopRequireDefault(require("../interfaceTransformer"));
var _excluded = ["component", "interface", "name", "label", "disabled"];
function RenderRow(props) {
  var _props$input = props.input,
    component = _props$input.component,
    _props$input$interfac = _props$input["interface"],
    intf_origin = _props$input$interfac === void 0 ? '' : _props$input$interfac,
    name = _props$input.name,
    label = _props$input.label,
    disabled = _props$input.disabled,
    rest = (0, _objectWithoutProperties2["default"])(_props$input, _excluded),
    components = props.components,
    form = props.form,
    config = props.config,
    nowDate = props.nowDate,
    baseName = props.name;
  var intf = (0, _interfaceTransformer["default"])(component || intf_origin);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "row-field"
  }, /*#__PURE__*/_react["default"].createElement(_fieldOld["default"], (0, _extends2["default"])({
    "interface": component || intf,
    components: components,
    form: form,
    label: label,
    config: config,
    name: name,
    nowDate: nowDate,
    disabled: disabled
  }, rest)));
}